// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"SearchBooksView__breadCrumbs"};